/**
 * Date format constants used throughout the application
 * Using dayjs format patterns
 */
export const DATE_FORMATS = {
    // Date only formats
    DATE_DD_MM_YYYY: 'DD/MM/YYYY',
    DATE_MM_DD_YYYY: 'MM/DD/YYYY',
    DATE_YYYY_MM_DD: 'YYYY-MM-DD',
    // Time only formats
    TIME_12_HOUR: 'h:mm A',
    TIME_24_HOUR: 'HH:mm',
    TIME_WITH_SECONDS: 'HH:mm:ss',
    // Combined date and time formats
    DATETIME_DD_MM_YYYY_12H: 'DD/MM/YYYY h:mm A',
    DATETIME_DD_MM_YYYY_24H: 'DD/MM/YYYY HH:mm',
    DATETIME_BACKEND: 'YYYY-MM-DDTHH:mm:ss',
    // Display formats for UI components
    TASK_DATE_DISPLAY: 'ddd, MMM D',
    TASK_TIME_DISPLAY: 'h:mmA',
    ATTACHMENT_DATE_DISPLAY: 'MMMM D, YYYY' // "June 25, 2025"
};
// Export individual formats for convenience
export const { DATE_DD_MM_YYYY, DATE_MM_DD_YYYY, DATE_YYYY_MM_DD, TIME_12_HOUR, TIME_24_HOUR, TIME_WITH_SECONDS, DATETIME_DD_MM_YYYY_12H, DATETIME_DD_MM_YYYY_24H, DATETIME_BACKEND, TASK_DATE_DISPLAY, TASK_TIME_DISPLAY, ATTACHMENT_DATE_DISPLAY } = DATE_FORMATS;
